<template>
    <Button
        v-if="type == 'share'"
        v-show="helper.isPublishedRoom(room) && hasPermission('shareLiveRoom')"
        class="edit_btn"
        type="dashed"
        icon="md-share"
        @click="shareRoom=true"
    >
        {{ $t('liveRoomManagement.liveRoomList.Button.share') }}
        <RoomShareModal :roomId="room.roomId" v-model="shareRoom" />
    </Button>
    <Button
        v-else-if="type == 'edit'"
        v-show="hasPermission('editLiveRoom')"
        class="edit_btn"
        type="dashed"
        icon="md-settings"
        @click="$router.push(btnUrl+room.roomId)"
    >{{ $t('liveRoomManagement.liveRoomList.Button.edit') }}</Button>
    <Poptip
        v-else-if="type == 'vodFlag'"
        v-show="helper.isPublishedRoom(room) && hasPermission('setLiveRoomStatus')"
        placement="top"
    >
        <Button class="delete_btn" type="dashed" icon="md-create">{{ $t('liveRoomManagement.liveRoomList.Button.vodFlag.title') }}</Button>
        <div class="api" slot="content">
            <Select
                v-model="room.vodFlag"
                transfer
                @on-change="updateVodFlag(room.roomId, room.vodFlag)"
            >
                <Option :value="3" v-if="globalConfig.hideVodStatusTrailer === false">{{ $t('liveRoomManagement.liveRoomList.Button.vodFlag.Trailer') }}</Option>
                <Option :value="0">{{ $t('liveRoomManagement.liveRoomList.Button.vodFlag.Live') }}</Option>
                <Option :value="1">{{ $t('liveRoomManagement.liveRoomList.Button.vodFlag.PlaybackOpen') }}</Option>
                <Option :value="2" v-if="globalConfig.hideVodStatusClosePlayback === false">{{ $t('liveRoomManagement.liveRoomList.Button.vodFlag.PlaybackClose') }}</Option>
            </Select>
        </div>
    </Poptip>
    <Poptip
        v-else-if="type == 'publish'"
        v-show="helper.isPublishedRoom(room) && hasPermission('publishLiveRoom')"
        placement="top"
    >
        <Button class="edit_btn" type="dashed" icon="md-cloud-upload">
            {{ $t('liveRoomManagement.liveRoomList.Button.publish.title') }}
        </Button>
        <div class="api" slot="content">
            <Select
                v-model="room.publishStatus"
                transfer
                @on-change="updatePublishStatus(room.roomId, room.publishStatus)"
            >
                <Option :value="1">{{ $t('liveRoomManagement.liveRoomList.Button.publish.issue') }}</Option>
                <Option :value="0">{{ $t('liveRoomManagement.liveRoomList.Button.publish.close') }}</Option>
            </Select>
        </div>
    </Poptip>
    <Button
        v-else-if="type == 'liveUrl'"
        v-show="helper.isPublishedRoom(room) && hasPermission('getLiveRoom')"
        class="delete_btn"
        type="dashed"
        icon="md-share"
        @click.stop="liveUrl=true"
    >
        {{ $t('liveRoomManagement.liveRoomList.Button.liveUrl') }}
        <LiveUrlModal :roomId="room.roomId" v-model="liveUrl"></LiveUrlModal>
    </Button>
    <Button
        v-else-if="type == 'wordLive'"
        v-show="helper.isPublishedRoom(room) && hasPermission('wordLive')"
        class="edit_btn"
        type="dashed"
        icon="md-image"
        @click="picWordLive(room.roomId, room.userId)"
    >{{ $t('liveRoomManagement.liveRoomList.Button.wordLive') }}</Button>
    <Button
            v-else-if="type == 'relatedReport'"
            v-show="helper.isPublishedRoom(room) && hasPermission('wordLive')"
            class="edit_btn"
            type="dashed"
            icon="logo-rss"
            @click="relatedReport(room.roomId, room.userId)"
    >{{ $t('liveRoomManagement.liveRoomList.Button.relatedReport') }}</Button>
    <Button
            v-else-if="type == 'commentManagement'"
            v-show="helper.isPublishedRoom(room) && hasPermission('wordLive')"
            class="edit_btn"
            type="dashed"
            icon="ios-chatbubbles"
            @click="commentManagement(room.roomId, room.userId)"
    >{{ $t('liveRoomManagement.liveRoomList.Button.commentManagement') }}</Button>
    <Button
        v-else-if="type == 'realEditor'"
        v-show="helper.isPublishedRoom(room) && hasPermission('realEditorShortcut')"
        class="delete_btn"
        type="dashed"
        icon="md-cut"
        @click="realTimeEdit(room.roomId, room.userId)"
    >{{ $t('liveRoomManagement.liveRoomList.Button.realEditor') }}</Button>
    <Button
        v-else-if="type == 'delete'"
        v-show="hasPermission('deleteLiveRoom')"
        class="delete_btn"
        type="dashed"
        icon="md-close"
        @click.stop="showRemoveConfirm()"
    ><!-- 删除确认框 -->
        <RemoveConfirmDialog :visible="removeDialog.visible"
            :title="room.roomTitle"
            @remove="onRemoveConfirm()"
            @cancel="removeDialog.visible = false" />
        {{ $t('liveRoomManagement.liveRoomList.Button.deleteLiveRoom') }}</Button>
    <Button
        v-else-if="type == 'relatedReportSettings'"
        v-show="helper.isPublishedRoom(room) && hasPermission('wordLive')"
        class="edit_btn"
        type="dashed"
        :icon="room.extendFlag ? 'md-create' : 'md-create'"
        @click="editRelatedReport"
        :loading="loading"
    >{{ $t( room.extendFlag ? 'liveRoomManagement.liveRoomList.Button.editRelatedReport' : 'liveRoomManagement.liveRoomList.Button.createRelatedReport') }}</Button>
    <span v-else>{Button type error}</span>
</template>
<script>
import { Const } from "@/model/ApiModel";
import Api from "@/api/Api";
import RoomShareModal from "@/components/RoomShareModal";
import LiveUrlModal from "@/components/LiveUrlModal";
import { mapState } from "vuex";
import config from "@/config";
import helper from "@/assets/helper";
import RemoveConfirmDialog from "@/components/RemoveConfirmDialog";

export default {
    components: { RoomShareModal, LiveUrlModal, RemoveConfirmDialog },
    props: ["room", "btnUrl", "type","selectType"],
    data() {
        return {
            helper,
            shareRoom: false,
            liveUrl: false,
            loading: false,
            // 删除确认
            removeDialog: {
                visible: false,
            }
        };
    },
    computed: {
        ...mapState({
            globalConfig: state => state.user.globalConfig,
            liveStatusPublishFlag: state => state.user.globalConfig.liveStatusPublishFlag,
            userCode: state => state.user.userCode
        })
    },
    watch: {
        loading(v) {
            this.$emit("loading", v);
        }
    },
    methods: {
        //修改直播间状态
        async updateVodFlag(id, vodFlag) {
            this.loading = true;
            let isPush = 2;
            let text = helper.localize(Const.liveRoom.VodFlag(vodFlag));

            if(this.liveStatusPublishFlag && confirm(this.tt('Message.updateVodFlag', { status: text }))) {
                isPush = 1
            }

            try {
                let ret = await Api.call("liveRoom/updateVodFlag", {
                    roomId: id,
                    vodFlag: vodFlag,
                    isPush: isPush
                });

                this.$Notice.success({ title: this.$t('Message.update.success') });

                this.$emit("update");
            } catch (e) {
                this.$Notice.error({ title: this.$t('Message.update.error'), desc: e.resultMsg });
            }
            this.loading = false;
        },
        //图文直播
        picWordLive(id, mid) {
            let url =
                config.picWordLiveUrl.replace("{{id}}", id) +
                "&mId=" +
                mid +
                "&showMobileEntry=" +
                this.globalConfig.showMobileWordLiveEntry+
                "&selectType="+this.selectType;
            window.open(url, "_blank");
        },
        //相关报道
        relatedReport(id, mid) {
            let url =
                config.picWordLiveUrl.replace("{{id}}", id) +
                "&mId=" +
                mid +
                "&showMobileEntry=" +
                this.globalConfig.showMobileWordLiveEntry +
                "&tab=related"+
                "&selectType="+this.selectType;
            window.open(url, "_blank");
        },
        async editRelatedReport(){
            // if(!this.room.extendFlag) {
                // create/update
                this.loading = true;
                try {
                    await Api.call("extendContent/saveRoomExclusiveExtend", {
                        id: 0,
                        roomId: this.room.roomId,
                        title: "0"
                    });
                    this.$emit('update');
                    this.$router.push('/home/related_report/detailRefRoom/'+this.room.roomId);
                } catch (e) {
                    this.$Notice.error({ title: this.$t('Message.save.error'), desc: e.resultMsg });
                }
                this.loading = false;
            // } else {
            //     this.$router.push('/home/related_report/detailRefRoom/'+this.room.roomId);
            // }
        },
        //评论管理
        commentManagement(id, mid) {
            let url =
                config.picWordLiveUrl.replace("{{id}}", id) +
                "&mId=" +
                mid +
                "&showMobileEntry=" +
                this.globalConfig.showMobileWordLiveEntry +
                "&tab=discuss" +
                "&selectType=" + this.selectType;
            window.open(url, "_blank");
        },
        async realTimeEdit(id, mid) {
            try {
                let ret = await Api.call("realEditor/createRESTask", {
                    roomId: id
                });

                let url =
                    config.realTimeEditUrl.replace("{{id}}", ret.id) +
                    "&mId=" +
                    mid +
                    "&mediaPublishFlag=" +
                    this.globalConfig.mediaPublishFlag +
                    "&selectType=" + this.selectType;


                window.open(url, "_blank");
            } catch (e) {
                console.log(e);
            }
        },
        //修改页面发布状态
        async updatePublishStatus(id, publishStatus) {
            this.loading = true;
            try {
                let ret = await Api.call("liveRoom/updatePublishStatus", {
                    roomId: id,
                    publishStatus: publishStatus
                });

                this.$Notice.success({ title: this.$t('Message.update.success') });
                this.$emit("update");
            } catch (e) {
                this.$Notice.error({ title: this.$t('Message.update.error'), desc: e.resultMsg });
            }
            this.loading = false;
        },
        //删除直播间
        async showRemoveConfirm() {
            if(this.room.status == 1){
                this.$Message.error(this.$t('Message.remove.living'));
            }else {
                this.removeDialog.visible = true;
            }
        },
        async onRemoveConfirm() {
                this.loading = true;
            this.removeDialog.visible = false;

                try {
                    let ret = await Api.call("liveRoom/delete", {
                    roomId: this.room.roomId
                    });

                this.$Notice.success({ title: this.$t('Message.remove.success') + `(${this.room.roomTitle})` });

                    this.$emit("update");
                } catch (e) {
                this.$Notice.error({ title: this.$t('Message.remove.error') + `(${this.room.roomTitle})`, desc: e.resultMsg });
                }

                this.loading = false;
            }

        }
};
</script>